import { Flex, Stack, Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import CallUsButton from '@components/interactive/CallUsButton';
import Body1 from '@components/typography/Body1';
import Body2 from '@components/typography/Body2';
import { getCarrierLogo } from '@constants/index';
import { Routes } from '@constants/routes';
import Image from 'next/image';
import { useState } from 'react';
import Container from './Container';

const Plans = ({ wizardState }) => {
  const [selectedPlanType, setSelectedPlanType] = useState(wizardState.planType);

  return (
    <Container
      header={`Plan ${selectedPlanType} options for you:`}
      w={['100%', '100%', '100%', '1000px']}
      maxW="1000px"
      px={['6px', '60px', '60px']}
      my={['40px', '60px']}
    >
      <TableContainer py={4} w="100%">
        <Table variant="simple" sx={{ fontVariant: 'inherit' }} size={['sm', 'sm', 'md', 'md']}>
          <TableCaption mt={[6, 6, 8, 12]}>
            <Stack spacing={6}>
              <CallUsButton />
              <Button
                variant={ButtonVariants.secondary}
                onClick={() => setSelectedPlanType((prev) => (prev === 'N' ? 'G' : 'N'))}
              >
                View Plan {selectedPlanType === 'N' ? 'G' : 'N'} Options
              </Button>
              <Button variant={ButtonVariants.tertiary} href={Routes.medicareSupplement}>
                Back to Start
              </Button>
              <Body2 whiteSpace="pre-wrap">
                These quotes are our best estimates and don't account for your specific doctors and prescriptions. Call
                us to get the best estimate of your costs &#8211; it's completely free and there's no commitment.
              </Body2>
            </Stack>
          </TableCaption>
          <Thead>
            <Tr>
              <Th>Carrier</Th>
              <Th display={['none', 'none', 'table-cell', 'table-cell']} />
              <Th textAlign="right">Premium</Th>
            </Tr>
          </Thead>
          <Tbody w="50%" maxW="50%">
            {wizardState.planType &&
              wizardState[`plan${selectedPlanType}`].slice(0, 3).map((plan) => (
                <Tr key={plan.drxId}>
                  <Td maxW={['150px', '300px', '400px', '550px']}>
                    <Body1 bold w="100%" overflow="hidden" textOverflow="ellipsis">
                      {plan.carrierName}
                    </Body1>
                  </Td>
                  <Td display={['none', 'none', 'table-cell', 'table-cell']}>
                    {getCarrierLogo(plan.carrierName) && (
                      <Flex w="100px" p={0} h="40px" alignItems="center">
                        <Image src={getCarrierLogo(plan.carrierName)} alt={`${plan.carrierName} Logo`} />
                      </Flex>
                    )}
                  </Td>
                  <Td textAlign="right">
                    <Body1 bold>${(plan.annualPremium / 12).toFixed(0)}</Body1>
                  </Td>
                </Tr>
              ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default Plans;
